import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Label, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';

const CustomTick = ({ x, y, payload, width }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <foreignObject x={-width / 2} y={0} width={width} height={100}>
                <div style={{
                    width: `${width - 10}px`,
                    whiteSpace: 'break-spaces',
                    wordWrap: 'break-word',
                    wordBreak: 'break-all',  // Ensures word wrapping
                    textAlign: 'center',
                    fontSize: 10
                }}>
                    {payload.value}
                </div>
            </foreignObject>
        </g>
    );
};  

const AvgCallMinutesBarChart = ({ displayData }) => {
  if (!displayData?.avgCallMinutesByIssueType || displayData.avgCallMinutesByIssueType.length === 0) {
    return(
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
              No data found for applied filters.
              </Typography>
          </Box>
      );
  }


  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={displayData.avgCallMinutesByIssueType} margin={{ top: 20, right: 30, left: 50, bottom: 60 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
        dataKey="issueType"
        fontSize={10}
        tick={<CustomTick width={400 / displayData.avgCallMinutesByIssueType.length} />}
    />
        <YAxis
            fontSize={10}
            tick={<CustomTick width={displayData.avgCallMinutes/3600}/>}
        >
            <Label value="Average Handle Time" angle={-90} position="insideLeft" style={{ textAnchor: "middle" }} />
        </YAxis>
        <Tooltip 
            formatter={(value, name) => {
                // Round seconds to nearest integer
                const roundedValue = Math.round(value);
                const hours = Math.floor(roundedValue / 3600);
                const minutes = Math.floor((roundedValue % 3600) / 60);
                const seconds = roundedValue % 60;

                // Return formatted time with labels: either hhhrs:mmmins or mmmins:ssseconds
                return [`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`, "Average Duration"];

            }} 
            cursor={{ fill: "transparent" }} 
        />
        <Bar dataKey="avgDuration" fill="#A5A8E6" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AvgCallMinutesBarChart;
